import { MeterCircleTheme, styles, variants } from '../MeterCircleStyles.css';
import { baseTheme } from './MeterCircleBaseTheme.css';
import { multiVariantStyles } from './MeterCircleVariants.css';

/*******************
 * Component Theme
 *******************/

const MeterCircleRedwoodTheme: MeterCircleTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { MeterCircleRedwoodTheme };
